import React from 'react'
import Box from '@mui/joy/Box'
import Slider from '@mui/joy/Slider'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'
import type { SliderProps } from '@mui/joy/Slider'

import type { MinMaxRange } from '../types'

function valueText(value: number) {
    return `${value}m`
}

function formatMeters(value: number) {
    return `${Number(value.toFixed(2))}m`
}
export default function WidthSlider({
    value,
    handleChange,
    range,
}:{
    value: number | null,
    handleChange: SliderProps['onChange'],
    range: MinMaxRange | null,
}) {

    const rangeMin = range?.min ?? 1
    const rangeMax = range?.max ?? 3

    const MARK_COUNT = 5

    const marks = Array.from({ length: MARK_COUNT }, (_, index) => {
        const value = rangeMin + ((rangeMax - rangeMin) / (MARK_COUNT - 1)) * index

        return {
            value,
            label: formatMeters(value),
        }
    })

    const { t } = useTranslation()
    const label = t('filters.carWidth')
    
    return (
        <Box>
            <Typography level='title-md'>{label}</Typography>
            <Box px={2.5}>
                <Slider
                    aria-label={label}
                    value={value ?? rangeMin}
                    onChange={handleChange}
                    getAriaValueText={valueText}
                    step={0.05}
                    valueLabelDisplay="auto"
                    valueLabelFormat={valueText}
                    marks={marks}
                    min={rangeMin}
                    max={rangeMax}
                    name="minWidth"
                    sx={{
                        "--Slider-thumbSize": "18px"
                    }}
                />
            </Box>
        </Box>
    )
}
